import { Component, input } from '@angular/core';

@Component({
  selector: 'app-sidebar-section-title',
  standalone: true,
  template: `<p class="section-title">{{ title() }}</p>`,
  styles: [
    `
      .section-title {
        margin: 0;
        font-family: 'Inter', sans-serif;
        font-size: 10px;
        line-height: 1.2;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: var(--dh-ink-4);
        font-weight: 500;
      }
    `,
  ],
})
export class SidebarSectionTitleComponent {
  readonly title = input.required<string>();
}
